module.exports = __webpack_public_path__ + "img/ludui.4a8ff036.png";